/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Recipients_1Inputs */

const da_privacy_recipients_1 = /** @type {(inputs: Privacy_Recipients_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi sælger aldrig dine oplysninger. Vi bruger disse typer leverandører (databehandlere), som vi vælger i EU eller med en EU-enhed:`)
};

/** @type {(inputs: Privacy_Recipients_1Inputs) => LocalizedString} */
const en_privacy_recipients_1 = da_privacy_recipients_1;

/**

* @param {Privacy_Recipients_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_recipients_1 = /** @type {((inputs?: Privacy_Recipients_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Recipients_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_recipients_1(inputs)
	return /** @type {LocalizedString} */ ("Vi sælger aldrig dine oplysninger. Vi bruger disse typer leverandører (databehandlere), som vi vælger i EU eller med en EU-enhed:")
});